<modal>
  <span header class="uppercase">{{'Chi tiết công nợ' | lang}} {{debt.Name}}</span>

  <table class="data">
    <tr>
      <td class="text-left">
        <div class="uppercase bold small">{{('Đối tác') | lang}}</div>
        <span class="bold uppercase nowrap">{{partner.Name}}</span>
      </td>
      <td class="text-right">
        <div class="uppercase bold small">{{'Địa chỉ' | lang}}</div>
        <span class="uppercase nowrap">{{partner.Address}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <div class="uppercase bold small">{{'Ngày' | lang}}</div>
        <span class="bold nowrap">{{debt.Stamp | date : 'dd-MM-yyyy'}}</span>
      </td>
      <td class="nowrap text-right">
        <div class="uppercase bold small">{{'Phát sinh ' + (debt.Total > 0 ? 'tăng' : 'giảm') | lang}}</div>
        <span class="bold" [ngClass]="{'text-danger': debt.Total * (partner.ID != 1 ? -1 : 1) > 0, 'text-success': debt.Total * (partner.ID != 1 ? -1 : 1) < 0}">{{total | number : '1.0-1' : 'en-US'}}</span>
        <unit>{{debt.Icon}}</unit>
      </td>
    </tr>
    <tr *ngIf="debt.Reason.length > 0">
      <td [colSpan]="2" class="text-left">
        <div class="uppercase bold small">{{'Nội dung' | lang}}</div>
        {{debt.Reason}}
      </td>
    </tr>
  </table>

  <collapsible *ngIf="counters.length > 0">
    <div header class="uppercase">{{'Các khoản được đối trừ' | lang}}</div>
    <table responsive class="data">
      <tr>
        <th class="text-top">{{'Ngày' | lang}}</th>
        <th class="text-top">{{'Khoản đối trừ' | lang}}</th>
        <th class="text-top text-right">{{'Công nợ' | lang}}</th>
      </tr>
      <tr *ngFor="let i of counters">
        <td>
          <span class="bold nowrap">{{i.Stamp | date : 'dd-MM-yyyy'}}</span>
        </td>
        <td class="bold text-primary nowrap">{{i.Tag}}</td>
        <td class="nowrap">
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{i.Amount | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{debt.Icon}}</unit>
        </td>
      </tr>
      <tr class="footer bold" *ngIf="counters.length > 1">
        <td>{{'TỔNG' | lang}}</td>
        <td></td>
        <td>
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{countered | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{debt.Icon}}</unit>
        </td>
      </tr>
      <tr class="bold">
        <td class="text-primary">{{'CHƯA ĐỐI TRỪ' | lang}}</td>
        <td></td>
        <td>
          <span class="text-primary">{{left | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{debt.Icon}}</unit>
        </td>
      </tr>
    </table>
  </collapsible>

  <button class="w-100 text-white bg-danger std-margin-top" *ngIf="deletable" (click)="delete()"><i class="fa fa-times"></i><span>{{'Xóa công nợ phát sinh' | lang}}</span></button>

</modal>
